const initActions = function (services) {
    const axiosCall = services.axios.Axios();

    const getInstances = () => async () => {
        return await axiosCall.get('instances');
    };

    return { getInstances };
};

export default initActions;
